<template>
  <div class="colorful-button" :class="color">
    <div class="number">
      {{number}}
    </div>
    <div class="legend">
      {{legend}}
    </div>
  </div>
</template>

<script>
export default {
  name: "colorful",

  props : {
    legend : String,
    number : {
      type: [Number, String],
      required: true,
    },
    color: {
      type: String,
      default: 'primary',
    },
  },
}
</script>

<style scoped>

</style>